import React, { useRef, useState } from 'react';
import { Layout, Button, message } from 'antd';
import { API_URL } from "../constant";
import { ImportOutlined } from '@ant-design/icons';
import { api_uploadOPTcsv } from '../api/uploadExcel';


const OPTins: React.FC = () => {

  const fileInputRef = useRef<HTMLInputElement>(null);
  
  const handleImportCSV = async () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
      fileInputRef.current.click(); // Trigger file input click
    }
  };
  
  const handleUploadError = (error: unknown): void => {
    console.error('Error:', error instanceof Error ? error.message : error);
    message.error({ content: 'Failed to upload.', key: 'uploadCSV', duration: 2 });
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('overwrite', 'false');

    try {
      message.loading({ content: 'Uploading...', key: 'uploadCSV', duration: 0 });
      const response = await api_uploadOPTcsv(formData);

      if (response.success) {
        message.success({ content: 'Upload successful!', key: 'uploadCSV', duration: 2 });
      } else {
        message.error({ content: `Upload failed: ${response.errorMsg}`, key: 'uploadCSV', duration: 4 });
      }
      
    } catch (error) {
        handleUploadError(error);
    }
  };

  return (
    <div style={{height:'100%'}} className='text-style'>
      <Button
        variant="outlined"
        type='primary'
        onClick={handleImportCSV}
        icon={<ImportOutlined className='icon-style' />}
        className={`ml-6 mt-5 button-style`}>
        ImportCSV
      </Button>
      <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            style={{ display: 'none' }} // Hide the file input
            onChange={handleFileChange}
          />
    </div>
  );
};

export default OPTins;
